export default __webpack_public_path__ + "static/media/Smart_plug_Current_w.6437768d.svg";